import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API = 'https://groovie-business-api-production.up.railway.app/api/v1';

const BIZ_TYPES = [
  { value: 'gym', label: 'Gym / Fitness Center' }, { value: 'retail_store', label: 'Retail Store' },
  { value: 'restaurant', label: 'Restaurant' }, { value: 'hotel', label: 'Hotel' },
  { value: 'spa', label: 'Spa / Wellness' }, { value: 'medical', label: 'Medical / Healthcare' },
  { value: 'corporate', label: 'Corporate Office' }, { value: 'religious_institution', label: 'Religious Institution' },
  { value: 'warehouse', label: 'Warehouse' }, { value: 'education', label: 'Education' },
  { value: 'others', label: 'Others' },
];

const Svg = ({ type, size = 16 }) => {
  const icons = {
    settings: <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></>,
    building: <><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="9" y1="6" x2="9" y2="6.01"/><line x1="15" y1="6" x2="15" y2="6.01"/><line x1="9" y1="10" x2="9" y2="10.01"/><line x1="15" y1="10" x2="15" y2="10.01"/><line x1="9" y1="14" x2="9" y2="14.01"/><line x1="15" y1="14" x2="15" y2="14.01"/><line x1="9" y1="18" x2="15" y2="18"/></>,
    mail: <><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></>,
    phone: <><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></>,
    globe: <><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></>,
    map: <><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></>,
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{icons[type]}</svg>;
};

const inputStyle = { width: '100%', border: '1.5px solid #e5e7eb', borderRadius: 10, padding: '11px 14px', fontSize: 14, outline: 'none', fontFamily: "'Outfit', sans-serif", boxSizing: 'border-box', transition: 'border-color 0.15s' };
const focusIn = (e) => e.target.style.borderColor = '#7c3aed';
const focusOut = (e) => e.target.style.borderColor = '#e5e7eb';

export default function Settings() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [settings, setSettings] = useState({ company_name: '', email: '', phone: '', address: '', website: '', business_type: 'others' });
  const token = localStorage.getItem('token');
  const headers = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };

  useEffect(() => { if (!token) { navigate('/login'); return; } fetchSettings(); }, [token, navigate]);

  const fetchSettings = async () => {
    try { setLoading(true); const res = await fetch(`${API}/settings`, { headers }); if (!res.ok) { if (res.status === 401) navigate('/login'); return; } const d = await res.json(); if (d.company) setSettings({ company_name: d.company.name || '', email: d.company.email || '', phone: d.company.phone || '', address: d.company.address || '', website: d.company.website || '', business_type: d.company.business_type || 'others' }); } catch {} finally { setLoading(false); }
  };

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true);
    try { const res = await fetch(`${API}/settings`, { method: 'PUT', headers, body: JSON.stringify({ name: settings.company_name, phone: settings.phone, address: settings.address, website: settings.website, business_type: settings.business_type }) }); if (!res.ok) throw new Error('Failed'); alert('Settings saved!'); } catch { alert('Failed to save.'); } finally { setSaving(false); }
  };

  const field = (label, icon, type, key, opts = {}) => (
    <div style={{ marginBottom: 20 }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
        <Svg type={icon} size={14} /> {label}
      </label>
      {opts.textarea ? (
        <textarea rows={3} value={settings[key]} onChange={(e) => setSettings({ ...settings, [key]: e.target.value })} placeholder={opts.placeholder} style={{ ...inputStyle, resize: 'vertical' }} onFocus={focusIn} onBlur={focusOut} />
      ) : opts.disabled ? (
        <div>
          <input type={type} value={settings[key]} disabled style={{ ...inputStyle, background: '#f9fafb', color: '#9ca3af', cursor: 'not-allowed' }} />
          <p style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>Email cannot be changed</p>
        </div>
      ) : opts.select ? (
        <select value={settings[key]} onChange={(e) => setSettings({ ...settings, [key]: e.target.value })} style={{ ...inputStyle, background: '#fff' }}>
          {opts.options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      ) : (
        <input type={type} value={settings[key]} onChange={(e) => setSettings({ ...settings, [key]: e.target.value })} placeholder={opts.placeholder} style={inputStyle} onFocus={focusIn} onBlur={focusOut} />
      )}
    </div>
  );

  if (loading) return (
    <div style={{ padding: 40, display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: 48, height: 48, borderRadius: '50%', border: '3px solid #e9d5ff', borderTopColor: '#7c3aed', animation: 'spin 0.8s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  return (
    <div style={{ padding: '32px 40px', maxWidth: 720, margin: '0 auto', fontFamily: "'Outfit', 'DM Sans', sans-serif" }}>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ fontSize: 26, fontWeight: 700, color: '#111827', margin: 0, letterSpacing: '-0.5px' }}>Settings</h1>
        <p style={{ fontSize: 14, color: '#9ca3af', marginTop: 4 }}>Manage your company settings</p>
      </div>
      <form onSubmit={handleSave} style={{ background: '#fff', borderRadius: 16, border: '1px solid #e5e7eb', padding: 28 }}>
        {field('Company Name', 'building', 'text', 'company_name', { placeholder: 'Acme Corp' })}
        {field('Email Address', 'mail', 'email', 'email', { disabled: true })}
        {field('Phone Number', 'phone', 'tel', 'phone', { placeholder: '+1 (555) 123-4567' })}
        {field('Business Address', 'map', 'text', 'address', { textarea: true, placeholder: '123 Main Street, City, State, ZIP' })}
        {field('Website', 'globe', 'url', 'website', { placeholder: 'https://yourwebsite.com' })}
        {field('Business Type', 'building', 'text', 'business_type', { select: true, options: BIZ_TYPES })}
        <div style={{ borderTop: '1px solid #f3f4f6', paddingTop: 20 }}>
          <button type="submit" disabled={saving} style={{
            width: '100%', padding: '13px 20px', borderRadius: 10, border: 'none',
            background: saving ? '#c4b5fd' : 'linear-gradient(135deg, #7c3aed, #a855f7)',
            color: '#fff', fontSize: 15, fontWeight: 600, cursor: saving ? 'not-allowed' : 'pointer',
            fontFamily: "'Outfit', sans-serif", boxShadow: '0 4px 12px rgba(124,58,237,0.3)',
          }}>{saving ? 'Saving...' : 'Save Settings'}</button>
        </div>
      </form>
    </div>
  );
}